import { Highlight } from "@CommonApi/merchflows/_merchflowId_/highlights/base-pogs";
import {
  PlanogramItem,
  PlanogramItemCommonNonCircular,
  UnrangedPlanogramItem,
} from "@CommonTypes/merchflow/pog/item";
import { RelaxedItemConstraint } from "@CommonTypes/merchflow/pog/pog";
import { omniAtom } from "src/utils/atoms";

const prefix = "planogram/extensions";

export const highlightsModeAtom = omniAtom({
  prefix,
  key: "highlights/mode",
  value: false,
});

export const baseHighlightsAtom = omniAtom({
  prefix,
  key: "highlights/base",
  value: null as Highlight[] | null,
});

export const deletedProductAtom = omniAtom({
  prefix,
  key: "deletedProduct",
  value: null as { item: PlanogramItem | UnrangedPlanogramItem; storeCodes: string[] } | null,
});

export const newProductAtom = omniAtom({
  prefix,
  key: "newProduct",
  value: null as PlanogramItemCommonNonCircular | null,
});

/** Item uniqueIds a review issue points at; the planogram pulses them. */
export const planogramIssueHighlightAtom = omniAtom<string[]>({
  prefix,
  key: "issueHighlight",
  value: [],
});

/** How the issue highlight paints: its color, its badges' color, and an outline with no wash. */
export const planogramIssueToneAtom = omniAtom<{ color: string; outline?: boolean } | null>({
  prefix,
  key: "issueTone",
  value: null,
});

/** Short labels on items (uniqueId → text), such as the number of the review issue they belong to. */
export const planogramIssueBadgesAtom = omniAtom<Record<string, string>>({
  prefix,
  key: "issueBadges",
  value: {},
});

/** The last click on an issue badge: which item, which number, and where on screen. */
export const planogramIssueBadgeClickAtom = omniAtom<{
  entityId: string;
  badge: string;
  clientX: number;
  clientY: number;
  at: number;
} | null>({
  prefix,
  key: "issueBadgeClick",
  value: null,
});

export const relaxedItemsAtom = omniAtom({
  prefix,
  key: "relaxedItems",
  value: null as RelaxedItemConstraint[] | null,
});

export const sideViewAtom = omniAtom({
  prefix,
  key: "sideView",
  value: null as {
    bayUniqueId: string;
    itemXLeft: number;
    itemXRight: number;
  } | null,
});
